export {
  parseExcerptMacroHtml,
  parseExcerptMacroText
} from '@databases/utils/confluence/excerpt';
